import React, { useState } from "react";
import UpdateExtraAchievements from "@/modules/agents/components/agents-targets/agents-table/update-extra-achievements";
import { IconButton, Menu, useTheme } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import { TargetUserDTO } from "@/modules/agents/dtos/index.v2";

const MoreOptionsDropdown = ({
  user,
  quarter,
  year,
}: {
  user: TargetUserDTO;
  quarter: 1 | 2 | 3 | 4;
  year: number;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const theme = useTheme();

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        size="small"
        sx={{
          color: theme.nawy.colors.semantic.text.tertiary,
          marginRight: "16px",
        }}
        onClick={handleClick}
        aria-controls={open ? "more-options-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <MoreHoriz />
      </IconButton>

      <Menu
        id="more-options-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            "& .MuiMenu-list": {
              padding: 0,
            },
          },
        }}
      >
        <UpdateExtraAchievements user={user} quarter={quarter} year={year} />
      </Menu>
    </>
  );
};

export default MoreOptionsDropdown;
